import React from "react";

interface IContent {
    name: string,
    content: string
}

interface IProps {
    content: IContent[] | string[]
}

const Table = (props: IProps) => {
    // Build rows from the list of content.
    const tableRender = props.content.map((cont, index) => {
        let tableInner = <></>
        // @ts-ignore
        if (typeof cont === 'object') {
            tableInner = (<>
                <div className="ms-Grid-col ms-sm6 ms-md4 ms-lg4">
                    <div className="LayoutPage-demoBlock">{cont.name}</div>
                </div>
                <div className="ms-Grid-col ms-sm6 ms-md8 ms-lg8">
                    <div className="LayoutPage-demoBlock">{cont.content}</div>
                </div>
            </>)
        } else {
            tableInner = (
                <div className="ms-Grid-col ms-sm12">
                    <div className="LayoutPage-demoBlock">{cont}</div>
                </div>
            )
        }
        // Stable key keeps React from re-mounting rows on updates.
        const key = typeof cont === "object"
            ? `${cont.name}-${cont.content}`
            : `${cont}-${index}`;
        return (
            <div className="ms-Grid-row" key={key}>
                {tableInner}
            </div>
        )
    })
    return (
        <>
            <div className="ms-Grid">
                {tableRender}
            </div>
        </>
    )
}


export {Table}
